import { Button, Space, Tag, Popconfirm } from "antd";
import {
	SaveOutlined,
	CloudUploadOutlined,
	CopyOutlined,
	ReloadOutlined,
} from "@ant-design/icons";

export default function StickySaveBar({
	status = "draft",
	lastSaved,
	onSaveDraft,
	onPublish,
	onClone,
	onReset,
	hasErrors = false,
}) {
	return (
		<div className="compoff-sticky-save-bar">
			<Space>
				<Tag color={status === "published" ? "green" : "orange"}>
					{status === "published" ? "Published" : "Draft"}
				</Tag>
				{lastSaved && (
					<span className="text-muted text-sm">
						Last saved: {new Date(lastSaved).toLocaleString()}
					</span>
				)}
			</Space>
			<Space wrap>
				<Popconfirm
					title="Reset all policy settings to defaults?"
					onConfirm={onReset}
					okText="Reset"
					cancelText="Cancel"
				>
					<Button icon={<ReloadOutlined />}>Reset</Button>
				</Popconfirm>
				<Button icon={<CopyOutlined />} onClick={onClone}>
					Clone Policy
				</Button>
				<Button icon={<SaveOutlined />} onClick={onSaveDraft}>
					Save Draft
				</Button>
				<Button
					type="primary"
					icon={<CloudUploadOutlined />}
					onClick={onPublish}
					disabled={hasErrors}
					className="compoff-publish-btn"
				>
					Publish Policy
				</Button>
			</Space>
		</div>
	);
}
